import { NavLink } from "react-router-dom";
import SiteLogo from "../SiteLogo/SiteLogo";
import { BRAND_FULL_NAME } from "../../config/brand";
import { useTranslation } from "../../i18n/LanguageProvider";
import "./Footer.sass";

function Footer() {
    const currentYear = new Date().getFullYear();
    const { t, localizedPath } = useTranslation();

    return (
        <footer className="footer">
            <div className="footer__container general-wrapper">
                <SiteLogo to={localizedPath("/")} variant="footer" />

                <nav className="footer__nav">
                    <NavLink to={localizedPath("/")} className="footer__link">
                        {t("nav.home")}
                    </NavLink>
                    <NavLink to={localizedPath("/femei")} className="footer__link">
                        {t("nav.directory")}
                    </NavLink>
                    <NavLink to={localizedPath("/noutati")} className="footer__link">
                        {t("nav.news")}
                    </NavLink>
                    <NavLink to={localizedPath("/despre-noi")} className="footer__link">
                        {t("nav.about")}
                    </NavLink>
                    <NavLink to={localizedPath("/contact")} className="footer__link">
                        {t("nav.contact")}
                    </NavLink>
                </nav>

                <nav className="footer__legal">
                    <NavLink to={localizedPath("/politica-de-confidentialitate")} className="footer__link">
                        {t("legal.privacyTitle")}
                    </NavLink>
                    <NavLink to={localizedPath("/termeni-si-conditii")} className="footer__link">
                        {t("legal.termsTitle")}
                    </NavLink>
                </nav>

                <div className="footer__copyright">
                    © {currentYear} {BRAND_FULL_NAME}. {t("site.publicSources")}
                </div>
            </div>
        </footer>
    );
}

export default Footer;
